import moment, { Moment } from 'moment/moment'

export interface TagSectionPayload {
    id: number
    name: string
    published?: boolean
    sort_order: number
    created_at: string
    tags_count?: number
    translations?: {}
}

export class TagSection {

    id: number
    name: string
    published: boolean
    sortOrder: number
    createdAt: Moment
    tagsCount: number
    translations?: {} = <any>{}

    constructor(data: TagSectionPayload) {
        this.id = data.id
        this.name = data.name
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.tagsCount = data.tags_count || 0
        this.capture(data)
    }

    fill(data: TagSectionPayload): this {
        this.id = data.id
        this.name = data.name
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.tagsCount = data.tags_count || 0
        this.capture(data)
        return this
    }

    capture(data: TagSectionPayload): this {
        if (data.translations) {
            this.translations = data.translations
        }
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
        this.translations = {}
    }

    payload(): TagSectionPayload | any {
        return {
            id: this.id,
            name: this.name,
            published: this.published,
            sort_order: this.sortOrder,
            translations: this.translations,
        }
    }
}
